import { HttpHeaders } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

import { LoggerConfig } from '../logger-config';
import { LoggerMetadata } from '../metadata/metadata';

export const SERVER_LOGGER_TOKEN = new InjectionToken<ServerLoggerInterface>('logger.serverLogger');

export interface ServerRequestProperties {
  url: string;
  headers?: HttpHeaders;
  responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
}

export interface ServerLoggerInterface {
  getRequestProperties: () => ServerRequestProperties;
  logToServer: (metadata: LoggerMetadata) => void;
  shouldCallServer: (config: LoggerConfig, metadata: LoggerMetadata) => boolean;
}
